export default __webpack_public_path__ + "static/media/dpm.ddc570ee.jpg";